import React from "react";
import "./style.scss";

const CircleProgressBar = (props) => {
  return (
    <>
      <div className="result-percentage">
        <div className="circle-progress-bar" style={props.style}>
          <div className="circle-text">{props.text}%</div>
        </div>
      </div>
    </>
  );
};

export default CircleProgressBar;
